/* FIT fit-app.js — legacy entrypoint.
 * Page-cache can still serve HTML that loads this file (or theme t/98).
 * Always hand off to live fit-app-v55 on main theme (t/102).
 */
(function () {
  try {
    if (window.__FIT_V55_BOOT) return;
    window.__FIT_V55_BOOT = true;
    /* Live layout already includes fit-app-v55 — do not double-load */
    var existing = document.querySelector('script[src*="fit-app-v55.js"],script[src*="fit-app-v54.js"]');
    if (existing) return;
    var s = document.createElement('script');
    s.src = 'https://fitprotection.com/cdn/shop/t/102/assets/fit-app-v55.js?fitb=legacy-boot-20260817';
    s.defer = true;
    s.setAttribute('data-fit-legacy-boot', '1');
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
